export const getInitial = state => state.initial
export const getInitialReadyStatus = state => getInitial(state).$ready
export const getZone = state => getInitial(state).zone
export const getModules = state => getInitial(state).moduleResults
